import React from "react";
import { useTranslation } from "react-i18next";
import UseScrollAnimation from "../../hooks/UseScrollAnimation";
export default function AboutSection() {
    const { t } = useTranslation();
    UseScrollAnimation();
    return (
        <section className="relative py-[40px]">
            <div className="flex flex-col py-[20px] mx-auto w-fit">
                <div className="js-scroll fade-top flex items-center gap-[5px] capitalize">
                    <span className="h-[2px] w-[25px] bg-[#A0642E]"></span>
                    <div className="font-bold text-white">{t("ABOUT ME")}</div>
                </div>
                <div className="js-scroll fade-btm font-bold text-white text-[35px]">{t("Personal Story")}</div>
            </div>
            <div className="f-col g-40 container flex justify-between items-center">
                <div className=" f-col w-100 w-[48%] flex flex-col gap-[30px]">
                    <div className="js-scroll fade-btm ccc flex flex-col gap-[12px]">
                        <div className="ccc text-white text-[40px] font-bold leading-[1.3] capitalize flex items-center gap-[4px] flex-wrap">
                            <div>{t("Hi, I’m")}</div>
                            <div className="text-[#BF894B]">{t("Aboud Abu Alrub")}</div>
                            <div>{t(" a passionate photographer based on Jordan.")}</div>
                        </div>
                        <p className="text-white">{t("I believe photography is more than just taking pictures—it’s about freezing emotions and crafting visual stories that last a lifetime.")}</p>
                    </div>
                    <div className="flex flex-col gap-[5px]">
                        <div className="js-scroll fade-top flex items-center gap-[5px]">
                            <img className="w-[20px] h-[20px]" src={require("../../assets/icons/yes.svg").default} alt="" />
                            <div className="text-white">{t("Over 4 years of experience")}</div>
                        </div>
                        <div className="js-scroll fade-top flex items-center gap-[5px]">
                            <img className="w-[20px] h-[20px]" src={require("../../assets/icons/yes.svg").default} alt="" />
                            <div className="text-white">{t("Specialized in [Portraits | Weddings | Lifestyle | Fashion]")}</div>
                        </div>
                        <div className="js-scroll fade-top flex items-center gap-[5px]">
                            <img className="w-[20px] h-[20px]" src={require("../../assets/icons/yes.svg").default} alt="" />
                            <div className="text-white">{t("Exceptional work quality")}</div>
                        </div>
                    </div>
                </div>
                <div className="about-me js-scroll fade-btm f-col w-100 w-[48%] flex items-center justify-center">
                    <img className="w-[90%] h-[95%] object-cover" src="https://aqaba-seasons.com/images-we/IMG_7529.JPG" alt="" />
                </div>
            </div>
        </section>
    );
}